import api from "@/api";
import { defineStore } from "pinia";

export const useComplianceDocuments = defineStore("complianceDocuments", () => {
	const complianceDocuments = ref<any>([]);
	const pagination = ref<any>(null);
	// used for rejecting documents on TempComplianceRejectDocumentModal.vue
	const rejectionNoteCharactersLeftCount = ref(250);
	const rejectionNoteMaxLength = 250;

	async function fetchCompliances(q: any) {
		try {
			const res = await api.fetchCompliances(q);
			console.log(res.data);

			complianceDocuments.value = res.data.data;
			SET_PAGINATION(res.data);
			return res;
		} catch (error) {
			throw error;
		}
		// return api.fetchCompliances(q).then((response) => {
		//   commit("FETCH_COMPLIANCES", response.data);
		// //   commit("SET_PAGINATION", response.data, { root: true });
		//   return response;
		// });
	}
	function editComplianceOptional(params) {
		for (let i = 0; i < complianceDocuments.value.length; i++) {
			if (complianceDocuments.value[i].id === params.id) {
				complianceDocuments.value[i].optional = params.val;
				break;
			}
		}
	}
	// function patchDocument(patchWith) {
	// 	return api
	// 		.patchDocument(patchWith.docId, _.omit(patchWith, "docId"))
	// 		.then(({ data: { data } }) => {
	// 			commit("UPDATE_DOCUMENT_PROPERTY", {
	// 				data,
	// 				patch: _.omit(patchWith, "docId"),
	// 			});

	// 		});
	// }
	async function patchDocument(patchWith: any) {
		// Destructure docId from patchWith, keeping the rest of the properties in `patchWithoutDocId`
		const { docId, ...patchWithoutDocId } = patchWith;

		try {
			const res = await api.patchDocument(docId, patchWithoutDocId);
			UPDATE_DOCUMENT_PROPERTY({
				data: res.data.data,
				patch: patchWithoutDocId,
			});

			return res;
		} catch (error) {
			return error;
		}

		// return api
		//   .patchDocument(docId, patchWithoutDocId)
		//   .then(({ data: { data } }) => {
		//     commit("UPDATE_DOCUMENT_PROPERTY", {
		//       data,
		//       patch: patchWithoutDocId,
		//     });
		//   });
	}
	function UPDATE_DOCUMENT_PROPERTY({ data, patch }) {
		// Find the document with the matching id in complianceDocuments
		const doc = complianceDocuments.value.find((doc) => doc.id === data.id);

		/**
		 * Apply updates based on available properties in the patch
		 */
		if ("info_link" in patch) {
			doc.infoLink = patch.info_link;
		}
		if ("locations" in patch) {
			doc.locations = data.locations;
		}
		if ("categories" in patch) {
			doc.categories = data.categories;
		}
		if ("roles" in patch) {
			doc.roles = data.roles;
		}
	}
	function getComplianceDocs() {
		return complianceDocuments.value;
	}
	function SET_PAGINATION({ data, meta }) {
		pagination.value = meta.pagination;
	}
	function getPagination() {
		return pagination.value;
	}
	return {
		// data
		getComplianceDocs,
		fetchCompliances,
		getPagination,
		editComplianceOptional,
		patchDocument,
		rejectionNoteCharactersLeftCount,
		rejectionNoteMaxLength,
	};
});
